import cookieStorage from "../services/cookie-storage";
import { FirebaseDynamicLinks } from "firebase-dynamic-links";
import _ from "lodash";
import moment from "moment";
import { APPLE_REDIRECT_URI } from "./api";
import axios from "axios";
import platform from "platform";
import { v4 as uuidv4 } from "uuid";
import ApiService from "../services/api-service";
import { SERVER_URL } from "./api";
export const dropMenu = [
  { key: "m1", action: "View Song Information" },
  { key: "m2", action: "Add song to Queue" },
  { key: "m3", action: "Add to Studio" },
  { key: "m4", action: "Add to Album" },
  { key: "m5", action: "Mark this Asset Public" },
  { key: "m6", action: "Mark this Asset Private" },
  { key: "m7", action: "Create NFT" },
  { key: "m8", action: "View NFT details" },
  { key: "m9", action: "Remove from album" },
  { key: "m10", action: "Remove song" },
  { key: "m11", action: "My Profile" },
  { key: "m13", action: "Log Out" },
  { key: "m14", action: "Copy Link" },
  { key: "m15", action: "Share on Facebook" },
  { key: "m16", action: "Share on Twitter" },
  { key: "m17", action: "Lifetime" },
  { key: "m18", action: "Last 7 days" },
  { key: "m19", action: "Last 28 days (4 weeks)" },
  { key: "m20", action: "Last 365 days" },
  { key: "m21", action: "Remove Album" },
  { key: "m22", action: "Save Studio" },
  { key: "m23", action: "View NFT Detail" },
  { key: "m24", action: "Remove from Playlist" },
  { key: "m25", action: "Remove song from Queue" },
  { key: "m26", action: "Add all songs to Queue" },
];
const STREAM_NAME = process.env.SK_KINESIS_STREAMNAME;
const demoStreamName = "siki-demo-stream";

// Kinesis disabled in frontend — events should be sent via backend API
// AWS credentials must never be shipped in client bundles
const kinesis = null;


var association = { eventType: null, id: null };
var count = 1;
export const getQueryStringParams = (query) => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
      .split("&")
      .reduce((params, param) => {
        let [key, value] = param.split("=");
        params[key] = value
          ? decodeURIComponent(value.replace(/\+/g, " "))
          : "";
        return params;
      }, {})
    : {};
};

export const display = (seconds) => {
  const format = (val) => `0${Math.floor(val)}`.slice(-2);
  const hours = seconds / 3600;
  const minutes = (seconds % 3600) / 60;
  if (hours) {
    return [hours, minutes, seconds % 60].map(format).join(":");
  } else return [(minutes, seconds % 60)].map(format).join(":");
};
export const copyToClipboard = (data) => {
  var x = document.createElement("INPUT");
  x.setAttribute("id", "copyToClipboard");
  x.setAttribute("type", "text");
  x.setAttribute("value", data);

  x.select();
  x.setSelectionRange(0, 99999); /* For mobile devices */

  navigator.clipboard.writeText(x.value);

  return "copied";
};

export function formatJsonToSingleLine(json, parentKey = '') {
  const formatted = Object.entries(json).map(([key, value]) => {
    const newKey = parentKey ? `${parentKey}_${key}` : key;
    if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
      return formatJsonToSingleLine(value, newKey);
    } else {
      return `${newKey}: ${JSON.stringify(value)}`;
    }
  }).join(', ');

  return formatted;
}

export const getUserDetail = () => {
  try {
    const data = localStorage.getItem("userData");
    
    if (data) {
      const parsed = JSON.parse(data);
      const userData = parsed.userData || parsed;
      return userData || null;
    }
    return null;
  } catch (error) {
    console.error('❌ Error parsing userData from localStorage:', error);
    localStorage.removeItem("userData");
    return null;
  }
};
export const getUserId = () => {
  try {
    const data = localStorage.getItem("userData");
    if (data) {
      const parsed = JSON.parse(data);
      if (parsed && parsed.userData && parsed.userData["_id"]) {
        return parsed.userData["_id"];
      }
    }
  } catch (error) {
    console.error('Error parsing userData from localStorage:', error);
    localStorage.removeItem("userData");
  }
  return null;
};
export const isLoggedInUser = () => {
  const token = !_.isEmpty(cookieStorage.getCookie("Authorization"));
  return token;
};

export const isWhiteListed = () => {
  return true;
  
};

export const getHbar = () => {
  const data = cookieStorage.getCookie("SikiAccounts");
  if (data) {
    return JSON.parse(data)["hbar"] || "";
  }
  return "";
};

export const getUsdt = () => {
  const data = cookieStorage.getCookie("SikiAccounts");
  if (data) {
    return JSON.parse(data)["usdt"] || "";
  }
  return "";
};
export const getToken = () => {
  const token = cookieStorage.getCookie("Authorization");
  return token;
};

export const getWalletId = () => {
  const data = getUserDetail();
  return data["walletId"] || "";
};
export const getMemo = () => {
  const swapObject = cookieStorage.getCookie("swapObject");
  if (swapObject) return JSON.parse(swapObject)["memo"] || "";
};
export const hasPremium = () => {
  const data = getUserDetail();
  if (data && data.hasPremium) {
    return true;
  } else return false;
};

export const hasProTier = () => {
  const data = getUserDetail();
  return data && data.premiumTier === 'pro';
};

export const logout = (redirect) => {
  cookieStorage.deleteCookie("Authorization");
  if (redirect) {
    window.location = "/signup";
  }
};

export const updateUserDetail = (userDetail) => {
  const data = getUserDetail();
  data["userData"] = userDetail;
  localStorage.setItem("userData", JSON.stringify(data));
};
const mapTipError = (error, message, fallback) => {
  const combined = `${message || ""} ${error?.response?.data?.code || ""} ${error?.message || ""}`.toLowerCase();
  const isTipRequest = typeof error?.config?.url === "string" && error.config.url.includes("/payment/tip");
  if (!isTipRequest) return message || fallback;
  if (combined.includes("insufficient_payer_balance")) {
    return "This user hasn't set up a wallet yet. They need to create one before receiving tips.";
  }
  if (combined.includes("failed precheck")) {
    return "We couldn't process this tip because the recipient's wallet is not ready.";
  }
  return message || fallback;
};

export const getErrorString = (
  e,
  defaultErrorText = "Something went wrong!"
) => {
  let message = null;
  if (
    e.response &&
    e.response.data &&
    e.response.data.message &&
    typeof e.response.data.message === "object"
  ) {
    for (const key in e.response.data.message) {
      if (typeof e.response.data.message[key] === "object") {
        for (const k in e.response.data.message[key]) {
          if (k === "message") {
            message = e.response.data.message[key][k];
            break;
          }
        }
      }
      if (
        typeof e.response.data.message[key] === "string" &&
        (key === "message" || key === "Message")
      ) {
        message = e.response.data.message[key];
        break;
      }
    }
  } else {
    message =
      e.response &&
        e.response.data &&
        e.response.data.message &&
        typeof e.response.data.message === "string"
        ? e.response.data.message
        : e.message && typeof e.message === "string"
          ? e.message
          : typeof e === "string"
            ? e
            : defaultErrorText;
  }
  return mapTipError(e, message, defaultErrorText);
};
export const isEmpty = (obj) => {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
};

export const checkExtension = (filename) => {
  return /[^.]+$/.exec(filename);
};

// Names that arrive as the literal text "null" or "undefined". A client that
// interpolates a missing value sends the word, not an empty field, so these are
// valid strings by the time they reach us. Every word has to be a placeholder
// for the value to count as empty: a surname like "Nullman" must survive.
const NAME_PLACEHOLDERS = new Set(["null", "undefined", "nan", "none"]);

export const cleanName = (value) => {
  if (value === null || value === undefined) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";
  return trimmed.toLowerCase().split(/\s+/).every((w) => NAME_PLACEHOLDERS.has(w))
    ? ""
    : trimmed;
};

export const fullName = (data) => {
  if (!data) return "Unknown User";
  if (typeof data === "string") return cleanName(data) || "Unknown User";

  const first = cleanName(data["firstName"] || data["firstname"]);
  const last = cleanName(data["lastName"]);
  const joined = [first, last].filter(Boolean).join(" ");

  // First and last still win, so nobody's name changes. The rest is fallback
  // for the accounts whose name fields hold nothing but placeholders: an
  // artist name, then the handle. Neither is a name, but both beat "null".
  return (
    joined ||
    cleanName(data["displayArtistName"]) ||
    cleanName(data["userName"]) ||
    "Unknown User"
  );
};

export const formatedDate = (d, isTime, monthFirst, onlyTime, notisAmPM) => {
  if (d) {
    const date = new Date(d);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    
    const time = ` ${hours}:${minutes}`;
    
    if (monthFirst && notisAmPM)
      return ` ${month}-${day}-${year}, ${isTime ? time : ""}`;
    if (monthFirst)
      return ` ${month} ${day}, ${year}, ${isTime ? time : ""} ${ampm}`;
    else if (onlyTime) return ` ${time} ${ampm}`;
    else return `${day}-${month}-${year} `;
  } else {
    return "";
  }
};
export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validateUrl = (url) => {
  return String(url)
    .toLowerCase()
    .match(
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
    );
};

export const isOwner = (email) => {
  const user = getUserDetail();
  if (user && user["email"] === email) {
    return true;
  }
  return false;
};
export const getStreamingBalance = () => {
  const data = localStorage.getItem("streamingBalance");
  if (data && data != "undefined") {
    return data;
  }
  return 0;
};

export const isOwnerId = (id) => {
  const user = getUserDetail();
  if (user && user["_id"] === id) {
    return true;
  }
  return false;
};
export const convertHMS = (value) => {
  if (value) {
    const sec = parseInt(value, 10);
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    let seconds = sec - hours * 3600 - minutes * 60;
    if (hours) return `${hours} hr  ${minutes} mins ${seconds} sec`;
    if (minutes) return `${minutes} mins ${seconds} sec`;
    if (seconds) return `${seconds} sec`;
  } else {
    return `0 sec`;
  }
};
export const HMS = (value) => {
  if (value) {
    const sec = parseInt(value, 10);
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    let seconds = sec - hours * 3600 - minutes * 60;
    if (hours)
      return `${hours.toString().padStart(2, "0")} :  ${minutes
        .toString()
        .padStart(2, "0")} : ${seconds.toString().padStart(2, "0")}`;
    if (minutes || seconds)
      return `${minutes.toString().padStart(2, "0")} : ${seconds
        .toString()
        .padStart(2, "0")}`;
  } else {
    return `0 sec`;
  }
};
export const serialize = function (obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};
export const truncate = (str, n) => {
  if (str) return str.length > n ? str.substr(0, n - 1) + "..." : str;
};
export const screenWidth = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return width;
};

export const transactionType = (type, isOwner, transaction) => {
  switch (type) {
    case "subscription":
      return "Subscription ReRenewal:";
    case "tip":
      return isOwner ? "Tip Received:" : "Tip Sent:";
    case "purchase":
      return isOwner ? "Nft Sold:" : "Nft Purchased:";
    case "nft":
      return isOwner
        ? ""
        : `Nft Created(${transaction["currency"] ? transaction["currency"] : ""
        })`;
    case "sikiBalanceTransfer":
      return isOwner ? "" : "";
    case "royalty":
      return transaction["royaltyType"]
        ? `Royalty from  ${transaction["royaltyType"]}(${transaction["assetName"]}):`
        : "Royalty";
    default:
      return "";
  }
};

export const validateForm = (form) => {
  if (
    form["thumbnailImg"] === "" ||
    checkImgExtension(form["thumbnailImg"]["type"]) === false
  ) {
    return false;
  }
  if (
    form["audioFile"] === "" ||
    form["audioFile"]["type"] === "video/webm" ||
    form["audioFile"]["type"] === "video/mp4"
  ) {
    return false;
  }
  for (const key in form) {
    if (
      form[key] === "" &&
      key !== "GIF" &&
      key !== "description" &&
      key !== "ISRCCode" &&
      key !== "contributers" &&
      key !== "royalties" &&
      key !== "subGenre" &&
      key !== "ownerRoyalty" &&
      key !== "artist"
    ) {
      return false;
    }
  }
  return true;
};

export const checkImgExtension = (type) => {
  return [
    "png",
    "jpg",
    "jpeg",
    "gif",
    "image/png",
    "image/gif",
    "image/jpg",
    "image/jpeg",
  ].indexOf(type) >= 0
    ? true
    : false;
};
export const kFormatter = (num) => {
  if (num)
    return Intl.NumberFormat("en-US", {
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(num);
  else return 0;
};
export const disableDates = (id, type, date) => {
  if (document.getElementById(id)) {
    var today;
    if (date) today = new Date(date);
    else today = new Date();

    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }

    today = yyyy + "-" + mm + "-" + dd;
    document.getElementById(id).setAttribute(type ? type : "min", today);
  }
};

export const getWords = (words) => {
  if (words) {
    const word = words.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
    return word;
  } else return "";
};

export const checkContributers = (contributers, role) => {
  for (let index = 0; index < contributers.length; index++) {
    if (
      typeof contributers[index] === "string" ||
      role[index]["role"] === "" ||
      contributers[index]["name"] === " "
    ) {
      return true;
    }
  }
  return false;
};

export const checkIsOwner = (song) => {
  if (typeof song["owner"] === "string") return isOwnerId(song["owner"]);
  else if (typeof song["uploader"] === "string")
    return isOwnerId(song["uploader"]);
  else if (typeof song["owner"] === "object")
    return isOwnerId(song["owner"]["_id"]);
  else if (typeof song["uploader"] === "object")
    return isOwnerId(song["uploader"]["_id"]);
  return false;
};

export const compareDate = (date) => {
  if (date) {
    let today = new Date();
    today =
      today.getDate() +
      "-" +
      parseInt(today.getMonth() + 1) +
      "-" +
      today.getFullYear();
    var temp = date.substr(0, date.indexOf(" "));
    const [day, month, year] = temp.split("-");
    var actualDate = new Date(+year, month - 1, +day);
    actualDate =
      actualDate.getDate() +
      "-" +
      parseInt(actualDate.getMonth() + 1) +
      "-" +
      actualDate.getFullYear();
    if (today <= actualDate) return true;
    else return false;
  } else {
    return false;
  }
};
export const getTimeDue = (time) => {
  return moment(new Date(time)).from(new Date());
};
export const beep = () => {
  var snd = new Audio(
    "data:audio/mpeg;base64,SUQzBAAAAAABAFRYWFgAAAASAAADbWFqb3JfYnJhbmQAM2dwNQBUWFhYAAAAEQAAA21pbm9yX3ZlcnNpb24AMABUWFhYAAAAHAAAA2NvbXBhdGlibGVfYnJhbmRzADNncDVpc29tAFRTU0UAAAAPAAADTGF2ZjU4LjIwLjEwMAAAAAAAAAAAAAAA//uQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAAzAABU5AAJDg4TExgYHR0iIicnLCwxMTY2Ozs/P0RESUlOTlNTWFhdXWJiZ2dsbHFxdnZ7e4CAhImJjo6Tk5iYnZ2ioqenrKyxsba2u7vAwMTEycnOztPT2Njd3eLi5+fs7PHx9vb7+/8AAAAATGF2YzU4LjM1AAAAAAAAAAAAAAAAJAUkAAAAAAAAVOS/q1nvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//uQZAAP8AAAaQAAAAgAAA0gAAABAAABpAAAACAAADSAAAAETEFNRTMuMTAwVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVTEFNRTMuMTAwVVVVVVVVVVVVA6kIZgJ4WFJuiMEYAGBkw1ADIgCZmIAFs0qGRvo/78QiRzlvCUMzVWS5IggcDQcVXao3FlTBVxq/YI5cMXc444LQlvrUYm4EFxKdryp/lAUqhQCIxgIOmVUG8RkcM94k7Sg2aswxhMuYXkWZKVBv//uSZECP8AAAaQAAAAgAAA0gAAABAAABpAAAACAAADSAAAAEzoIwlS0aTIpI7qn1xtAhcRYwh6FRAaoncB7NQkv7TdFDS1QKiPzDbgcAKGsJD78sGTNHhix0Big7WIDjkTlFZoybafxUAjowGGTIoDaFw9GdkWcI8N1M6biRIGVWajrdlol3ghpE8WmGERTYY+8QRoGzZhGomkMhZjqfCp24QDDUMu04rQ2TqCMDZ4xlYJHkukTQFqBC0HGVzFA6LBlQI4F400FE1DkMS4wk0e+LfDIFv1SP/YjTXVxqTVw1uAI7NSmHoOhEXnMqGCnBYMnAlwrt2K92JOy05jizGDu5K8LUthTyPI/cYp6l25vdDJINbItlLYtSCpD6A2AC+gGrCABqISFN6VvyUveAjpwUzOJTJHZQlsnt4qrmEatcHKZveyh1LLv0EslEON3SLhd9VQCALWPKw+D5SzsuYZANNZe8BbgyGLoOQy+SRVHtmy6HTnmRmACCigCuHBFnmK4LAj4avdnIrTrZ4+X7+98PIJzppDznOvafdqxfBSByPf/7kmT2jAAAAGkAAAAIAAANIAAAARh1ADRNY1yCoCAJqYThlFez4qr7P73LoAOAHA4InvDQ9Rv2xIgF4AjAEBSIe5KxdqtvduQcAxEW71eGegEMf7OfiEUip9V53/TVyRgQxGBHwjarY44+w52mGX8W8QsHOWPGjfMkHOXv/01/83vf/NPffvf/fyYTA4m4DNwU0jBcwDEZpXUMMgBkBsUgZKHInWlsHyhtNwzET4ZQ2kBqZtDYm2BYkgiD8LBgEKfemsP4CGHRyrYPdyhawiYg42jS2Js7fZMROtFD8JmWOU60gjQBYAMBqBDENHrQskYmaMeKRCD/S6seVTiGMn+sH4XBNqxOHRpOOlevAXw53ysZM2VlXmqF3AHYDmccf0gIYoGRvSQBYAPADMx0McVeuFQ2OnEOMOtEOt0gHuBAH4yH+hd4x+KjGv77oSACAI2I4EYVDBQkAYCxAL4LYIQDkLxnZuGUDkLx/87/9KU1/S/pr4p76+fCAEEGAJbm5LJL7FoQ5YDWGvGMVBnp4MGLKY4w1ABh1KGqtyeVgkB26zr/+5Jk/4yHXW0iiw8vUO1tpFFh5dwVUW7ATLExAn2t2R2GJeh/6EeBwJIMxEbYTkAsj4O5USoxIL5KIoGAbjwtR0SHI/iWNCQRljCNuDajlxoyj1hvWF2/BPdggyc0lWicgLvtGkVNj4oVbUVaYb3JY8gjKH8F5Q1N7xQmsy2gTk8gTegOtEkFw2tgrSjtsLyQIFSw6bDfagukwu9GoysYbQLyJ1L//2GhAAOSWPq3JcqsStKFYEAMnQuM4xwg0EIGqo5jS3GZIFB+4vODxuNYkWm5gdtMtLVJuTCWdIBmXFJoZsQ4y06fnZYwRonbbzaBfXX7rfOoQus66OUIJrMiQRjDpIFSIcBgE1iRdZk2gzYvMCtFFufmpGeJOcK0lWmEaUXEaTkZxknmoGFdFCcsptRlGjWKjxgMazNRNtRyBdpU2wjUiSL1AEVAiXIxS/D8LMXwGAxjgfJFmmti1Wem9Aiibu5M8BkwshSDEL3w7AAIz92ILFj0NzSAKO+o5EF+QygIJicIvggGd+oyt9Tpc19Tq0exIAgdCo0TSL6ggqBM//uSZC0OwnMfPYmPMFBNo/exMeYKCZB9CgwwboEPDmGI8Q2AQA2MUpz3OpGMYOSDSxadk1wnd6mQvdikLQAYXWfQR9/7AgWDj0NdZCD/4nrPo1vw+fcoMhiXB9y0cnIZPDD/k+/rXOASgo6Q5Z9CsIPLH+SLXezt54Da+zBkj/qA4AgNID/X7+OLHOYoQDPNN4exJ55wmEUdx3FAx8Tg4cxRYP/hifj4ow54fD2Q/q8yQpJQBRCAcghghAhhLRuK9Unilh8JpWSgb3c1e9NoADOnpghgNA1h0cR/XHhDjT4MVBjyYfuxGt/xA4/3O+J2yH/bzmvnFQqmqqqQGQJcSqKGIoYzZwigUUWjNc8xSGQQVQOGDUBp0s4OcHwAQCABTCGEwRQwRTTYwNDBB5ogzseWfWplOYaaaCKb2TdbJ0WoM1X0bOt1IVm5gaHAuD+fvIawJJz7iiPZdpd7xQyXJLA5bAyGZRga4mw+DcCsGLRGzTRMakMAQA5woJenDkFkwvKEz4q8vZW5h9eQwTDl45EhCDrF8gMGOpV79P+j6cBUqv/7kmRVgANVLkbNZoAAPWJY0KeMAA2ot1+5h4AQ2hAr9yJyAjidJpdbrNprdQABkYltStqaSqeb+Dw4YUW1KkUGwiMa467+q8W84OG7hzJO2KJFP3G3iKxk1BZoOa1xt5reocZxnfuGrfG4/p/p3SPE3//X6+t+u9sipfztsARXZe2Dw4MPQLqSlBTiYTNwFAfsAgHAw2GwFAoAAFuB9sZsGQBk/ZZXM2dz/3/UuFP+KjlKP++imjzu6rA0CQK/1jbP/OgRrhWBkDMwZAWTLES4MCEIAwfQIDABAiVXSpVK/wYAC0mWx95X8TGQbMLMjVag+F9RIcqNymHaLHCnxuyrtff559wy/+2uk1JBo3AIKsBMKAATG7IiUKA08RPaoaNh0JmKJ4DZFh4hWVXRwzU6qdWAGAYAJ5hBdpKEa3JEM00FDiQ8TfORyONUvJl5I9Lubk+CG3hn3KKnixg8/YxoqgW1kxVT/X//JEg0AOAyMIAE83eZqzEYBDM9DDaAUOLwoRuQIBEzESGg5f7LHuLctUpEMh4vNJmDNRNFCSVY+tD/+5JkbowDcRfLF3tgCDfCaZzsiAENVKMeT21jyOKK5jWjsZRuGx4k01u02muq2uma3PllTVfua98U+n04yqap0Wt4010iJe/9jL6q25ir7GUe91EPQ++gBUoQFZEGABPqVGp4MnfgaJKGDoB91MmsujKZ6HQKpt9Xu/MGgjv6xO/+OUeg414v8WtT4KHZ18eqFBmTAngEEwZ8H8NraSbDE9QDIwQAAcGABIIPAbIAgpmYJwCIZIBo0eOGCFhUcFAo6KMOgNAxMMaA0qFAIINEoow66jqECGAqYOlFKHLKrGF4uWCJBfR3jc56gLbK9TTXXG94pG2uXBmszbOUmSEtjk5WhIqzNJKyvMbvmbNG2y/NaNedSd4zbzW8T6iau/a4DBWmu178ms1g7gy1xfN6296xfPrdsZvWJHiUvm190xn+kD01jeK+DrF5M//V76387p60vvOc7zO+cSrIEWNokCcx+7kzSIcwgBUyTBccBMwRCQwoQtIctIBlyTjxKdpuqVpuu3QKawtcjwuszhcEEw41113sJgUIa/AlRGo1jTbK//uSZIiAhlpnwxP6eXCSJnhxd0k+UCinGM9lJcFjlKNlxg1oZpgE0l6RKJ4zkIwqULG0KymuxFNXu/bg1s7vYavC3QzsbsZ6tY+bSPQ/iY+AhBHKXON67ZtsbSss0fqnK3vRqOiO/aytSuWEOzSD/4FH/uqMBkAAwgAzjwVHLMa4G4FBJEwAhZMdmWzJDyFfVaKSMXbvadqDHGgtTh/ZbPWq+NReuAWDIlmGipIzNqU0vKt3pJ0rP7desnsX+UBEKS5ec2YRlOerhuHQqIzI604TuGAJqgiVFXDH77pi9VLLWLGG1zVzDQtQdZWTHNUp7myBXMkpXioCMKZYwyQAEDTCQKYUNANiqwKaTkgk0ckA8AqM/VKWU7rS/nbrS6I1MUQOahDI4WrRBcJG2vl1e/oizP7B1ID31vR11a1er+7tuw7ZfRdp1X9pKgAPErrQBgAAwUwbTbWQZMKcEU4STFUECs2WMwXfhKWmxqNRKJdpYzOFhxcjOAvAuYfBvUTzC01xeMji642+eLqktmWkhb2oyy7DAqLmyOrffp//SAAlAf/7kkQriIKdKcbL2EDgU6QY6ntIGAn0aRZPYSLBSoxi2e0kWNjaACMhgngimzoV6YfoGZnhhODkaX7cEORQjqODL6MHMXAVD2gpiBaXlCOow/n4hmnuykXn7OOf6lR9wMAihEHytwLhZJ4RHZ0JDlq3VS36O2QAwAQIzAUDmNq9ygwoATAvkTAzctIteRERqYNDykmlGLvMn+S9cVSsSQfFvujad7uZ8lrhZxICqsSGi1gsYqeBsX9qfV///Wr/U37vd9ECuQAwDAJTA4C+N9NvowaAaDUrwOCLXlYJy0j0jo2qDQwA6RGbsqexfK32JpUPbef579wqNrQkjjhIFir1MATjL1DZna8s77Ps8j//+j9G63V+mgAIUibJIAHQMgKJubBk+5gQA3kAhqSwxdZpCwqzKKNPfddC3bH8LumeuJrpjlqitmCGPzM9z0tqf8aqGe8XULAYIJ2vGChlBOlXPtMFKxVCO39M0j7//p9sb5cU1PAEcjlturYAELeA5c+FghP5erWoAv3WTVo1FdvTgYnEN5JhBfexjCNUe7vLiKf/+5JkRYAC7B3F09hI0EBkGS1tY2kLeG0zlcQAOSQQ6TaYMAZCakMa+VeEp0EC16bUWh95NVk4AAk3HP+gBNUtGZ3ugWEAKFi6H9d+NzMf7EK/xOpcZw5PkZoJkQIZmOB1Q9EH1e/XE0cq1Dncn0VR3V+VaeDKxa/Bz9e5b1Zv3zjgk38SqErLUes9Xl2PGPHZmVAKzXbbbaRtDOA7clcExrSSzDyKi3biWms/IzoJqCNl/J2GIQLpGZNZFQVUFNRjqoe8YkY+OaPYoOPGCUGDyVhmjJQEVeQsCL9dAEr2e7+v0Ho0GosAgEZGx1F+DlVUE7nYq7QodRXlvTsoLiRzEBUkCiB3SF76SjcqGZBANaQDj0MnzUvpkTGYIoTnyLl9y+Xxlg+AZAiRBP6ZffYvl83RM/6BursVyyM2bnCAE5/3V/J92TU1Tf//+y0y4gxvB///lzYYGBjPgAAWi0CIVigQCgAAAANVmyIxDL/vp0530YBv/oQsCem/cc6ZCNyX+xfdMzNuD4Eb8oc/rD8QAAAECSJtySRwNiQSCAPQm4OA//uSZGMAA/FN1u5iYAQ2Asqdx7QAj/lPWbmmgBDbDqu3GsADACGRcQ/MSQOgjERMHugYSOYMQdRVb6cZrsS0AKIEuCmAoB4LyikdUiu8xMhhiRNklrdUrUMMalGtGl6LIl4+YnjFJJ1/yKXh3DKNyVOrWpSP/HspI2PrUkYt19H/pJOkkbUTFX6///WpaKkjK9CAAAAklutsuAAAAAAAA/h1MRNFkJ2pnjjWfYKoSnkbTiUTkaNxS6iVWa5qDep29vUmaT+ZT1tKYBALt0t1skDCiyxcd3UZWfKmULbcKxBWVPl1ZqmfqvGSWPI1jsXa0oGaZSPpqXXOoctyp1CD5aaqMOw6nVF8Ae45JT0Wuk6pNulr2ztj2zDomZp0S3l22u/fcQ98f8s9repvb/9zTNdKTp5gatRQo8sAAp6ukBlufi5MMDwqa4rmC9z3m81AERVqsQzmY1lFy8ty1R+IGo5SPLERCJSIa+3cVku9ayG5BK0wnDQ9EPowrC4xQd87qEYwTJUxkCQxxJw3XYY+NR4jHLAWFg4BYHIDAYgICZZjN//7kmRsgAOISNXvZWAMNQQqOeeUAY3gryBO+WjA5JSo9PQU7mxyxADLSYmgPV5UsN46k2Q9M6/owp6UJTthyVe5wHep90S+6a2WTaNTW1eqlUcSRPAUVKQMVT309VcVnQAgBE044ogBPtj2aAIk6U3g+UmyBGHA7YqC9X9BV0UYHGSjH7v5vQ9nwKX3/8TPCxcFRQDGCq9ldNUAAAAKe8gA8DwCCw5xI4wiAMwUAE4MBcMBcy4BkxCgXzBGQZMFs6owHAiTABAqBgBoXAALQvVE0+uSFVjN9UPPF2vPiNnFH76Zi9qbScW+vif/buHN6VwPq1P8xfrOMZhb3fwj8SuE6bAnQ9dYt1gBAONx6RsACNtwqDuJKXBxmyInoNESoxEmjEhyORjH+CX8YTOtktuKD2absfelIWhfwX73+75EAuHgAwMBEwpBM+gr0xRBkxcbw4YLUCEUYRgiZfEKbQU6eTAfZizAHmDqAQEAqg4CZFdPJqLiQWXVldq3nBMPzPYu0UfnJ0YAzr1km2nfu4lcxrrkPtdxvvmmHzzhE0sJ2LD/+5JkhAgTdSbJY755uDckKi09I12NUI8dLvlpQNmQaLTzoVY4s+PO////+sAIkJyzayPFMt+DuKdPRKmC9i2lV4gaB8jId2Kb3oA0iJEC0i9QoibzRD/xf9ycSDwkkkSLv3oAAAAOuJEgABikx0Y5r2pLswLbYyDF0wGCQzFA4z3FYwC+Y8y38LEAOhGh8FgDQQOnHIxTpVW2m0xICI9WgkDo/dtoS3dbnDgf1Zr8VJZcOY633xVq2JxSkZrn3w0yIm2+1aAgMrmmtjAAcniMdlEDzFeDh7AgdKRUsZvJuFGyuXmyJI3JbffocdOU1S+UVBPhma9tpRmHKc8IdYAMlcaAAMA8AACAhmMEgeYDYD5gIitGOGAiDQPQ4CowowaDE1KUN/cKMw+QMjkDQEuCBLB39p5m0vHbGcKif5yaBfFPckPqtUqKq1vtKz1USSPb04JeA5ca9wgN1tDyVDpp6VelAQAOSy2u26jLrkaIvJatvbZ8yu+bjxcoFFJoNWpE2V8OCu1fHMxCwP75LMqqu6ibIUEHu0rqAAAnykAMAwBs//uSZJ+IExEeR+tdYHo5BCotPSJ5jJR5Ha9pioDWECe1gKFOKg+GBypwYD4ExgkgcGUqAEYIoJJhhAAGGsBiYNp1pqqnXGCqDaBPBUaHAiO3Jw7UoWxfYQxPsbWAeZtW9Jc2VnT0L/3+nJe8uhEpsKICJLeDSdbE1//9n/17vr9vo93nVqAAG+/AAdFgoOJZKKuhvTRXQn2XALZzyW3uEOAlQg6klK0/awgNnuaqrRZO9JB1XR7No49ABbSjYYDwP5kVq+jQlBgyicmQuCkYE4HwYGiYdAPZiaGSnEgP8YhwMZy0RmBYOHCwFtoxSTalefhZ1DPi4hhPGUxP/kzvl9zflWiytTcIbaMex5nuTSA7rG+v+xX9Pf2d336Uf6yFgL9tdtIABUxo8BhrIlNmI9phwambQRB2QiKKRbq0ozWT+2+Aqo+65r1pObMHgYR0g+61+vIPDfVVAEbAAF4TAlB6M/BSIwEwPjAQHVMDUHYwOAEDDNAtMMkCQwhjoDbCN5MJgHg77AhlA26M7dyUYpeX2wiilrpFhvLYYnCOIU385//7kmTDiQNUHcZL2EqgNCQZaWUCX8ykeRcvaSqA5Y2otYYg5v1vn+OAmtD+nQ+y0dTv7OjGf+hF7/tp/8u79KFpACAbsr0rAADFYGMYPY0KNwGIU1QzlwweMQfeQnFVGbismCju/EpkKWt9FzXUoZfzgaBibnoDMnVULAcCsYFQDJsToNmJEB6YCBCZlVA6GBICiYQYAxihhYGLOhYdEpsZiMg7HYWmtKGKAgIkmDG4naR7vZXcohN8ILGvjc1szCmzWhX7rA9zuwB2sTsJh4wtzm3paq3FJDY0cQc1qDICJItRXUut8Ys++B+TE0kKy6NdyJCg1SLgIFk7Ii6gQADJISUqMIDMPEqBrDRIUYGQL7hoFFbVI6UJgmvdeOd8uKSo7EAZ2EFFQIAA4KpJLFwRGQWOvdPf////6f///9YWA8BwXZwhBuGIeCMYRQRoc+YSgnkxDhiIAbmHyiydjqkRi3hgnAgGbIgIAOA1SMvd+snx8QwMptCZDZtQk8/vnbPv/g1et5CnbX/0rf2K1q/aS19N4ccs7EW+8z1dY2yxflv/+5Jk44kTMB5FM9gyoDjjWT1pI1cPsIEQT2jKwR4Ko2nNFOBm627R/s2e/+cJtaBOoPfpvwiP27DaCvr9T6G34AgKTtiAABadmxlp5UICBQPSCyqAJYRAZEzmQRf4OHjC6c+QMHf6NrCVMQFZmJI3aVLWYcObF+s/xslNE5Z/////63BADRgSAVGt2YQAhaDAIFQMhoGEhA6MJABExBAfTEYOhN74zIw+gQTuqjKCwEKWiwaQy7Bcc7Cbi0KbSozt0fk4Xm/LX55Hbn6iE8FhhodJOTFyHoPpOtCjNcsKLVrgnwtH0lk1WJD7Btq20ksXcg3pQhxkjTWOSxEAB9gqAJJRiApg0MZwMstHgFRgLDJtRE1sPpbimcQ17Tr7gUmWLCPq4iVaJEfWziOb8RBCh6NEuxnsTv//////1SUAAUAeCoNpquLSmGiCmYDhEBgchVmAQDEYXIKphVgUGF8ZAb8B0Zh4AvHOWAAEA4YQ47kQ5TpA323i37UYrz+nm4wopJHT4tqWdrvDjqPhcHrGCl6XLPSR0gHziBKlyxOtVbgz//uSZPCNg/0hwwPaMqJCY/jaa2gWDsR5EC9oypEPDuNdraBYkrVY4zcgmxi2yzkNC4BU8aTqUg7ZIX4DaJ3jAICLktYAAXq040MEWCg3we0aisXlmBECDTi1B8OAViPDjiuX9hiVugtzKxDe6Pw6RyqB+bLjSq7IEjv//u////+oiyigCJgABHGY6wcAAFDAZFGMfUDsLgKmDWAwYaoNxhymQG1KUeYS4OB+SmqMWtSacWeq0Cm3WNERapBJUvFEK12VkcMsceak0EMGwIKMGkhopHS55tZ1oHXFNooKMZACcUS2IshX1qrc+gsOe5wq1QcjE6kte9hUUAb/owMFh51gwYLFR8BxmhE/y3ltGFSjDgOi1Auoo1gE/6nuaImtmAj9zOiciLTPC19wKGBSzx9G///Rf/T72f/9n/SqAAFa/VBBoAxgChCmFYm6DgIzBLAkMd8AQwKQEwMGICgsTBjG7NK0fwwXQTTYZDdrj9O5G5XNLl0iXytmTBCfl5Lts87OSVPo2LUzm4PkkJhjZ1pTlXIvMqlPPV9K+l6q9lUVR//7kmTxiRQCHkOT2TKgQYO46mjIUA8gdxDPZKqBDY7i2a4gWLPQ/VaT/GvA6KgAAWcrIAASOJDwHsXiApmB8Yv212FioGbeMQeR11ZuHDKz+NrMK3XZwv7bZaMMVZRttyp96TiMBVH///+z7////q//0EhUqABcAMYBiMd5sAwVQOiQT8yBwbjAjAGCA8TDYB1MMAx81+iejCyBPO1YyhS0xmHqDPzWjIyBjLaK/8gQedRLJf76+vVDr3qFq2u4wLlgqTPQaULii5yHhWiASrY+1ru9iBRSk5Fp9DRVcKEI4D1saLodC7ngtrjbwmg6oUYG/U4wACmwHYOEhTBOFNljtWXaOipQ5s5SicGfFVALabxIXZ6hJ3lGOr0HzGaVKQQ6vDwefr/09P//v1a+ivjv/7GkqjBHBgMCoQ84zeAzFWBbME86MwBRJDA2BeFiah4j4xqkTD72XjMboHI6E1MoDjEQEwMIL5qCM4gMcF5FC5o9kX1a9CI80ohGsHsnRk1+TC9ZlY2hltbz1BfS7vf9+qvd2Fh+F+t6bNb4w/zcFvj/+5Jk8QiTbh5FS9gyoEQjyMpnZhYP6HcPL2TKgQyQIpm0lUiWQWhSMQvMqNcmkNUOW944jraU77FKUOZzz1l75Wff7S3FAi3vyXb7D3XivtbT9+z5WOeU2XmlKbF9La3zTHTObjUv+sk6XxUvadefjXxw7SK5VQG7pUGx+GRHGBpabuHCAlaTEQYSRJGMXlXLafWdL3Ts37sN8QB7rFUc8PO7qySttaYDqIh0FVLIS1CYiUgQDWbwKBKdaXjTKgVXDDgsLJUl1yr60kmJDcVDBKJVVjyz2tX1OHrIIgATBtBSOJp1QxmQNDCUInM0wKQwcgQzDlAOMWsLoxO1KjfXQrMW0KQwUALTAhAaMAoA0wAAAFcu1ZiQiAMl0DdSqjftG0G9W2tT1ati+Jyiz3WIEipOd12i8sL7wUhyP4E8QRq4M6HMdq6gspBWjyOao1fV5v6AjRIbmCaDRxZZ2XFq3yhXsz3YeZhRJwMwllOigWbAsahyFHND2hUBEk6CnVKNFa7oCBh5ggayzJIFFzarVGYgwh/wlA2eqsIECECT+FVf//uSZPWN1fxrwAPbYqJkI7hha4UcFfGtBE8wcUkSjeJJnaBwm+fp0s7nJePgN1SufH1NXN2lUnJ7ylyWVUCyqH/fR/Xo/R/9vsJlLvc6ta+uMBsBIwrANTvzOlMVgCUwQgOxasEwGgfzDIAqEhJDF/NxPfc8YxjQWz5DANXBxgy41fix43KASXuMVE4iSTcmLs2iRJTjCkLZ9KknMRVSUliphcTrQTRQWQE9ahjnfqcWGpRmm3VJI+tbWr22nUG/FrGff1BI5rXknJpEmm509Zm7yclkEqR02oU2c4w+Z0a0ufy86Lp0uzWM6kQwRLTbpa+stFqaBSEsizOF6vjGyagSSZlNBE4qUZOOoAAQvsFWSMBESk3xgBIA41ZjX4mMgxkIm/CqzAJ61+imd/ZNn9DkKnr8Tz/GOZnqP7ybxOp1mmU+9Byn9E8gqpFKex/lUWoqbfDmOSjcZ5bZfe+1FCAcDKYaIXZ6aHumNuCmYWBXBolCLgwFIxFALzH+DpMVZ1E3gFkDFKDHOTkM0nMaOToS+dmH7Bhi26LO82BHxokmE//7kmSojYXUbUAD2kqgVKQ4qW2GVBiRrv4vaSrJHI7iSaWVUNcsrIlRIF3h4UnukfvnRcgcWYbsFG9slmlqhZQ7JBMnQ/Ss13KIrI2IJxeYkYK0wY1+iaTBMUjCS7cDu7NpG2iyDLUiWGT6XbkzKUjqSB0s7BKfgrBjFGmSCTkKBlaUYTM4mnI9CKtJJSaTzfJI8jhOoLtML+bTaUl8wVz2FEEjiUCU0oA2IvOCU6EIi1H2IuJDriIgmtLQQee8Eq9lCyOM0SLuzoCXoSyuivVRm9Bzg46aEDZgm9HpkP6l9uz930hpmnS7e7bT1aIKCTeUjYVS0DhZDAjHAAoRoiBAAwN46AaYZQNhuXCCgodgaBHKADFGUgZFDFBdQXvHkBJhFBi1c8zXL5esnS5UmHhEfx82RIZZIqSaOumqkCjvDIIZu6pl6lCMvq5H2/crNFj6GeW546ZpIa5nSELDMu1Ps2MsqUOOeRm2CkSFw6cIRuTsABrkAJPARxFCeBBeMmLZdG52IrCvKLlgiZaEbVuNNVFMsu0NESIQCwUESVrUfB//+5JkWg2UKWLCA14YckKCGKZo41YPxTkML3RjiNcFYomdIEhMocvS1n7/6P9pH1/+76f7dntwkwQgCGAmDKZuiTZgfgXmAp7GtYep/CRZmR4WGHceGhsAmE4ZAwDUMmAr2kty9aW5fI2cTIKCn80WHMHC7RZIgHRB+SHJ/nzz6Z9LY5vw+Eq+akXfpVa1I8pVsTqtZ/spTy6d2rd2hNDB8y1LrindpH009krcdSDd/EPq7YVUUbmG1UDhRIiBCsI67V4ZK77uAjfmgaYvm4o5izwIOKBJIfHZhka4Vt2X2MZ79n+v/R/PU+/+ugBFSIAgHFPjUXjjAYIAMBwKlowBAlCgDAUYrg0ecg4NE0RASv55ak7bz093k1NPa3V3uikJsShwsSpOzqH5JBt7eYrXIAsALhesu5l2nuVQ2QzHvr0e+hjqdKCVpX+AAoKQBIHNXmU2mLzom5lWocu8B/p9VrQM8ZmTelZHWykPPuBcLK/p7P47/0+R/7P/t0jIACqwEEkwz/cKA2YTQZwMQCQPJjgZQCJgS0mRbQFhCkcyGAnT//uSZFsIkuobRLM9EHAzYziiaKY8C7hpEE7wY4DFBWLZlJSQoLt/ju9dJ9MQpcIjmc4TP0kgu1xFloa1PVX3Gd1bVdDtbP2i5WhuQS7fqFzcUbVCMUVHvSuTJjWDv7rPkb38ELZ1gA2ILcm3wj4cnSKhpos8cJjaST1rEKBc+geKFYl3in//T///////XQABW/6UUeRGCxn1LBhKBhAO5giCTgPuW9MLgpOCABIhlTieWRQ5R2EgDaa6PVU46b305YR7goQIgYXgucNCxKZWbpM7ppLv+7FG2JGNrdb/b+tU3/RSpuAA7Bat08QalrJ2/i6RkBSF2QCXi1/TtP2Z3OwdIutojSyQ9692q3+zvJs/v6L/b0f/9DAAkY6HTqXFzDwISqnzZAaJgYJGcyWEDCdKMrUUUCiZLPoBxq4c66PWBYIJKopcKCwcnExsiiWabXb+xigim3N2vWH41UXtLTMy58trVS4c24CmVqQehtgwiVpNNScUweAEALUwjGWMChZSrIZuTiIA/E4E1EpaItsN5oWcazpGahJtVSMV//s////7kmSKCBK0GsXLpxuQM6L4omRDWgwILQ4s94AAyAVipFyIINno7v7Ff9DtSgEACrkAVmmCIBHMyqAYtjAQHx5pDAQBVFgEARhqGAuP4kNSULfRWLXs1iDp3epzsef9hR4x4ES59LBq0GlKfLKfiu8gVPO+laupmK67CdE1uyby7+28HIyguLDxyXl96AB1ygHe4Zw+Jm/EpOQmOtaD/eW3FgGzluKlOx5QQAnSWQ+n2Mcj+zr2p/9X/9L/+wAACGAU2EgUPIxgMXAKEJUNyB2XERIMdAkGR0x7KhGD1UnhiUM3M1UJ/elqeu13YkSh6FCIHvHxQbP3VRNpaYbwxB1d4eFVyjLHXnEzqRilU/UccykE0PjQzJKaeErlHUqMVQAA77u4RltVq0PB65eB4WldNKRIKDmpKKXfOB97gsFvr1dH+t/Z0bWdH++v1/TI1UjDAfA3NCot0wewOTDAxjEAUyQGBCAZgwBZjEM5PtAOOEaB5ULbfPUVbjSOoR2B4pGbHy6mshP0uusoNSG4Yd8132mhmjMdMlu6OZ5qa4JIr5T/+5JkuoDDAB/Ey6cboDBDWLZkI1wMPGUPDvFDQMADYog8BFjyPU/vMkY7M65lcmvS+HqhMbO+eFbza5K3OI5u0NdV7S6eog9pc8jK06cFvHCvr2AIDPfCg8bGlA56llruhjJemZroGZafRyHVRnZ2R5maW06O7cIs56GNd/Ymi1vT3XrZoYj6G///2/6yJOjIGhmcoMGCwAwYrUhtkIo/FBnMphIhvBqi0kgcTJbtALkValzrh2EhKczZidTeHvrkSc6IC92o70/O/FYtndXJyRZoWy0ly3sMrl5qRteqaVTTkTKZB9946klnPI+ZRiVKlCFvijfI+oeQIxtGUWYFfun77Z2GpO0gAAE/qICuVfRQueyvsaJuVFxqPB3TTxVWGy0uXUOQDAjJlGBg5t/Yo9cT/1y/Vd2s+r/91aoQhgIizKAYtMA4C8wHwOCYy8wCQB3aMC8BIwbQoDQJAXAQYwYBCl00Fk9FcncGIdNFZwhNjzRx34ujRVmrlY6iiEu+hDOyoCyekjBHQhOTkSBCY47h2ibjIwlxFoNJwg72xPN4//uQZOgNBAtqQgPdGOI6I9i5BwIWD11lCC9wY4jTBaLkPAhYGjHDEKRqCSAiMGgl2jESMZSbHu4qTNAYMiIkzoObk0pE5CTDSJvzjmkYUTjhUjSAAQSRCCRlSKPS5fSY84XB6EhDRk1zszMZXESgw5FS4CjDKVp6VHUpQCyeUx9Pc0u6S6RVPi+ltVxodWpl/tJp2La65iNoJEQwp3owfBQLpZ0IwXjFjAyQFAuyeTxCMJbhBNBcqZ5/B/LMz+ZlFPZxvhXxEuQKpSXThaafJ+emd/vZqufUIkMzB0uJ3vSM5P8u+jA13NNerqhutW8Ir/4cNd9/vLHczCy6R08DwIWz2ThxIBXaoKKrBChjJPNAh+ahPDp6t61tPdUWSdSNTb9PF16E6Wfs/0p/2fhbXqu9VSAAoChgOBJmRmwyYOAEIhN8wjCIhAhCEw4B8x2PM/GIwxiA0IB5HFpyVsusVrq/c8MwX7x+Izbx1HVDJ/EczXGFFWiS0wM+vm2fp6o6td9oy3SYiuMZbQj1HX2JOnkIpNGcyUzMVX2Lnen3kqAm//uSZPCNBJFqwQN+GHJEYoiCByUWDdkFDC7sY4i0hWLZAwiQqs2LW2r7Wrl6Ydvm0cXGKKiZwwtjfEnvKqXVp2t0ZSNyyGsh040YhB7OiU6Jt84+WKAiIwAABmpAB7oHKiS/FmowThoWJiK1pComs+D6IEUhdtpDHqAofegUFCqFHn0K+v96ehPf91cYr36O3tp6FFsQKJh3B4RjWCBhRJmlAcLBQoJQYYjAEAO+OswUEFh3gibjS+pW+HsEzquSVwhGwKU3NXHze3pvJIKc3uVmxFB4RJWwaNba6bkWRkpkFj9MXM6FMECWAygp7WfmGjqaioS5u5088dO0rGAUeMR5kaTgSs9mQcjgXx3auxMUsrqTgxNsIyCQZH24w+UbG2Sa/qMixG9tAzs8GVOt1hA+OYbSfBWJ1aJO3tT9XnVrkvXKPG7P0LS56dz96A8wV2sYpArSzlKlZAAC7xEFJ4fDYkUKHMmXFMEoAMwhAQwzLI3dHkBCEny06HYxZ1+357/ueMfCT7ZeE7OR9muyIUXL5KtRrN6a/qd7UmubkjFdH//7kmT2DZUSbECL3TDiOwFomRsHEhDRrwYu8GOA+wViCMwUWKsPhq2XybtcjQwz6YM02N/RLS/e+SK52vTUyh/GYi3me/4O3sanG17UXzP9yhmlcgtBy66wAXpEDLJpj7QITVdvKAjF7CPE11IQuJCrzJADJYDCyrXuGCVesjvb/Mirb/Rtv2/993/0f1NADArPriQMdQEMHEw0EDWklYMEhiYNV569bGDwGuyG4w7dTPeoa/ilEBEZCxlYwWkpHRsUhOT4QUfmuRWqS1z3fc1pMehNW95oYjKaMjl0H3OKbp5+lO01zPByGThc1rk+CPI0rio4M4pvkZzMscEIatEbewRzUpponJaZnjm2cHqBN6iG143UyHwC9z0Kw2/Q/itklfHkmrFHmouTEgKCE4sTrZV21+c9XyFmr+jcR/1VN0fccBoYICQ9nYwxwAMwPEowaAlIoiBEwkA0wcMk2GJIwcAVH5xY0HDL0A2b51uYW5vSRuquRtfNVdIdW6wIBdSa48hLGND3hhszrMZVmwTRDaysmvy5J9YwbMT6GSIcX7n/+5Jk442D7WfCE6YcQjUBWKZhIiQQKbMGDvBjgNAFYqT0iJAhq6LCe3d27FmkbfpQ1M9cF5iuQ+FtY+x1jRaCh0i6OdFkKjzgDrkAcLpDmsgSExsaMEt18xeHa2p+tQqpB4iO1scr+23a/+v6Nn/9Fi7avR9iOm1LGkGA4knkWHmCYAmBCsZzB6HAMD5MDjDR2PgJ0xYAlL4pTxWnwqe8VeOQUdcHVMZDYWwCpBGHOEGMIFYMJEMXYsEVToMtUFAyXRCwhmWjjMULIzpytDMyfbXInQUjVqEFilJ90FuSCeTBEXnHOMzi4mQYoD/oALFHpkhqZhicSiySUKjrDQ5CMK8t1diEBTgHycNFOL381TItLm+NqxfaPQi1toLGh0rLvQk5/kVvY3f/6v9X++LV2+r2ssZoFlkABD0EBwco+gYKAQYAgEEJUrePAUYRgAYGmIallOEBUpa41KO1bPSHeO2+8FbV2tVq6v11i3TvLVMZZ72U3J28cY+F5lu2LGjOEWSenWIxWW5cyR4YcOKDlQ9TZCVrwjNyagk3wh6makCH//uSZO6NpBtpwYuoG3IwQwimPCNcEd2zBC7wY4C+BGKIZ4hYSgkBkbY0qGR8D5K0kCQmBo9SnXjTSsLSuqITk/rMMOxIqqiWsXBBQ5uNBEnnnAwiAZt86ABz3yqLbDJovgoggFwiPDo5ylEF27PZ9dVjtK/X+73exuvd1NQjTkiKSLpDIZMtcdKtQ8aHzvs0ewwCGTU4mRLfi/x8v8h9ppU7N4pWl+a10LOwWrEZdnoefPmDgs7WtmalmVvhGQ4fHM9i/k1snIpnFe33X9bC2LpGm3NuZsnll/qkLJowZvuSe9gPa/wG/SvuKtuyBvXQQIKv5FdSkqIX7IyYw+FIuNWypdiFpRFGNKKBAMhYSvDxqCrFvMC+2Nj2fZ//XnP3a9m1Ec7//VUAQwAAlSQA8ZARUDQKKheEHUjVaEApgyucglIKv9ZrXLw6E1fJPs00f1RH6oUGkC1AFnhmSb9sMlciJNPJUNDJSqnwtrnZftXiIRIal6l5nTL/LN1p05lcrlryW7bNbc4ioaw+IxYs3E5kLkY5Ugzc1YyM0AgAoa0pEf/7kmT0iASEZcETrBtyM6DYyhoGFA5NRxFOGG3I34Ni5YE8iCAZS0Qw6QYko++33oqMBB5JaBFr76ob0bSt+zVq1kYstlBs9wqUCsisiODqNL/M0IpLqTaedq3aedv+m/36W2N49YkvjAACTXuPwUNIjDUMCRlC417mAQbGhgipAQPOWuv/jKOXN8RkahsYzT8xm5XvGpqee9sFEFFmlGM/DcKg7n18L1KzFP7icnSR4w7VrdDPvbmCJTchK1SLiM9GXZYbHIaONHT8zEtQb4Jc65Ejm3vkvuKdsGGomZB4wseYWxAAAhuZVZ0Fkm3buHBVGcoDModeBwsFDQQXcSX3uofsrp7Q/NELU9v1BWnB8xIkxZuzU1MUTe3SBZ0nsheWmZmvrOltNHme6gjP+/LE2pTPL7Vwu4W99WpZ6PYk2+9myaEyP5+vtvqsIFawm6sqLkmCIWHTEVCRVGFD5NMqWjwMBh4xV0PTawEJNdj1Lax1nqe3DcoGGqG6sCE+WVp1ZVBvDcyQEp1QdO7EmLDTO0PDjIHMntgObporAo5EYKP/+5JE/AkDnVxCM7sYwkiD2O1vAhcPzYsELphtybKjYaWODCnWFhsy1HYnqp9r9s/KbPCt6RdIkWMPm9kOkTpFiRDYWMOok21b/8WdY1nxGI+hJAYACBG1ADyA31SJGST2tCOHaI0jz7Lrgz3/doNJeCGX7ti0sccf/rXqv22P7f/va6jr927VZpAQEptxElKXF3TtpRGha5RQLX3WpAgjCJoMPLfsW+HEc5vN26RMpJYmUt13RsVOm37hl1QPHNGhOYpghC33Mi1hPWXQ1i07f/nn6EUKJzOJpmR2Qi2sy7HOz8naB5UIiYqRiZ9ZShtULzT3K3i54b8VIiClXsnW6ZKRLUCJRjFcdsIPZCJikeSmqpqnJU4AtFNC21lz422rtp9X4tT+m//b6EVqu/79R3/RVwYDgifDKGCi3MIOA51dBLEDGphUmew8GIALOn9lUhtXRw0KMRLP7U9dBDdMLxFqmUrFKuIJKuMPQqUjg6ES7BjU3iaHk070F6uxWzR02UWTa2SbO1VGOtyFodecRk1LLO2OjjV3TJHkc5h9spvs//uSZOcAhABqwQO7GOI1g1iZPCNaDxV9D04gbcjDAuJk8LSIOgfFUkNaG2Ob14RL8+ldblucnm8ixlvhhbadFsT35lRJKjaaCyoDAF2lAGwMWmKXwLCEXJhpmtj7CsrI3veEDEehCYx7rYVSWS2lvtXfq3q/t/9nUno33XGE+RlhOeMABkdRyEYgAgCQcCgAuEwdl5gQExo4JIsBjbzlG1OdYSRfOpnyC9mE10ghBy96J1Q1nyBZsxCBZYULT5+NGhzk3gVwiIMIOJNhNzRHGH75b5C1QT6fogcyQz3hCIwvCsgsgumRObLAjrEEXcOFs9C8jtQ2cUaMIRGRw+OqkTIhDx3CMMxptjBlRhuVA2iuyBFhU8mCixddxhFWihzoMAkDzlqqJCS3522/fxztdzOln/0fl/db9FRRQwHGE4u00wzB0cIBZ78rAQURAWQNzXwcBMNjUtEOu7KtmdNpJFIqEI0hR2rJ7/67k8lPNZWJXc5CamN5tVuREQhWLOItzoLr6Du90SwstOlXsmVcSgcaRLa3h8ls9OV7apOL226p4f/7kmT2iYSzasADuzDSNSDYlhnpAhFRswKumG3Au4MiZLe0QEti06lC7LNMQj6jjhrvVFZHm2zmz3yYrYw022g2EL9Ky2ejVEbnHZLDdAAGpulUs2OXiYbs4gB3WvQnXicLA7XYENEe9SDYqszmDlWmr6tXwB3EdjfXt2+xSwJkgwKDP/FBUBmFBAlMjdSNA4HzP8FigEhsr59Z/UO6QO3p/195c2ogf+50+/ldxeymQGy+dxLb5nfDsvuv0ZeX0dPQcydKRhJPd23MZVvaNL8+sjKSd5VH+Q6CU+yfuO6Wacms1smLmkJgT6fZ9y87jZns5itYCbp5RvRyN+3JiiVO5ewzOz/uWyNth1v+5kAQVWY2kilqYl5YXrBDpk/Xut1yzi9i7CSmDHFLLmaWfo5P//lv060N+JWO0ez61S5wUCsxR2MLAKq8WDtvkWQwDQoOZgwLSesNS2+MWOxARjzKUu4XVTjPawmGKPSwcmjhrR6CHy6fYr41VUrlV8KO1e276YbhApu2+5ukTmzrspTHolTrWcreVVGqfTebfXR8s9H/+5Jk8w0EjmzAA7swwC+gyKkwJyASKbMCTrDLwL0C4yiRGIjoKQZK4MO6WLNLp3ffy4t+1QWhy4LucQZ4yXLanY4zcrEj5ZHX3Xg7lIpLTpYCCAcDWy8Jdmuhy9iqUsOx4toSKpkgcBrMyt1xewWFhQ4g87c9xokpfeu1VbNkBgz8w05VoqfeSS4xkd+cnbAREbbkRSajKIRs34gORlS6wvxlepFAwdR3s1/p+Ix9SyTDVDRvzNVYmxKF4Hn2KyzlDJk4+YKEzKUZr/ZvdE0K9WRGBrybJ2IfojSJS9B+XUZtv9i1YND6sHM+uVvN7S5P77nbM7PFs30quqAMstc0CoMCTMZTD1KehN7ogA+B3qXKCcWEKnUzhEWUyJacerM0nHqQGGDv/v/1d33du30qIBHIwADc5TrsxKAkQgKRAJUVrEgOHRuMDhZUaD5Y6fRsqJIFdjCnym0oxLUostMXKGXQiNJnp3vRNUeqcLH6XBxGMxOy1IeEOzYvh2vF0WIZA21pWd58akljRkHGas8ecZ09TInO8ThCloFY6oZ3Qgnm//uSZPEABIdsQAOoM1A+4LhlGeYQDXUHEU2gTcjQAaKkNDwApo2SmOQp3hjl1AYe5AjM+OBbG8+dpIQVd9tFOtKswpUr45LNP1EucIOkcAYAfGDUnEhz1lnxQ+RSknl3nGhU4HxW0WJC4xJ7S1JG7er1DGZ8at2kceZK1PubCy0ZhFGt4VS1nVtwvfIIWl/VVjyzUBQ6LwjwEf2XO8DQINP9cU7PWMj9kuX/TbfwpmynqLitLclnA36Ki8qucUUedBhGzGhsQYLB0zM5qZJWtXHNZacPpEmRZ55xHXtM4u5V0pwzrrCtG5d7J7O5yoFe/LsMNnLD6Ddc86v7uDUON5GoxGB/raJPBZvHSN8si9f/eSSmXKhlTnp1RmAstztH9OO2X+j1WMvTL6/Ub/us0e+rUjbVAIPAAOsFAUOXwUJioaePB7J1wKWjAUmEoeMDoLue5Jdaebk349ZZsQ58Qr3pmJSe1lHJdYb082SqxrH1O/YayvX0CTv9LjrNakHPTB3OxJDWdYy0FYLux0ET1WcyrqsiM6OlSaMyH5OgWkpCX//7kmT4CdTgbD+LqTLyPmBocQWsAA6NJwbOGG3IzY9iCPCMuKY9JohpyMqVpTMR1mh1Cq0lqJRwdzLS813SwOq6qKMIdx+PjplgWNFqOgLihTclh94ggcBgsfhXPCGkRKIIL7L4u1FyZ9IZYVQCAq8yg8rNu7UDqXkPpSuwp1kVpuNPv6GrbanmrByqktotHzq/uEUsgAoJPLPkxWA0MGSzF13V6hzkY7R0ueW9SjzSMtpUQkVKjlZQ9FxaRBLnAgKmDSQanK0PObKQehG41hWhMQtK/FPyUAyeot+bk0CaeexmPkZkIKZFFhVlLY3YgfUYcjd6/f9icfM5YFXroRz5QqLuRQmAwuR84k1pDECSDZCEEAAEMqJONIEmEwHIKQstjiFCWhKqGSNCx7gMbJpC5So2o2d6Ge8UZEnb/6P9tSE0r//epWVhQFHofsYWAxeaWz7TlJCokMaBlnB2oWooqnlypb3bNEuebq8vUp4/aqQnbero12cXR5UHszTP1N4mcx6WTFtqS0i5cutQOZOmdi32FVkS+Itnc567Fn3TbU7/+5Jk9YkE82xAM69Dcj1gaHUV7wAQJbEEziBvyMqBovRWJADZ1ekpWbTuYqM3PRkqrJVs6rn7f7IUUo6Kn7TnxNLfsg5xLduZN5cvW7RhRklQnQeAgSA6AA4uggCkVF1WoskqNc8deV/zukUSggKBamletHtI7/T6Nq1b9F9bSmlH9Qy6NtupX9ncRiQyHTaX/QZIQCfcvjT/I9HfIveIh0spmewoa7eSbRT36i8I9pjLzx4DBdA/UHZRbr7SZHdVXilL82jJLSK+r0svzMQnE1K2rw1s0Ijq2ci8WqWpfXa11NY2R05koYRD3zC0umg6d3S6Q5olmdKsnMGqfepFzFxUs3yQPxHF5lbAAAJ2DIN5kgI3+D132K6HbDLTaj0UYMa7tZrXHJUtxN6dbd5WMQtVF26q8RK7FmwPd7c0/x7nqF77aSAXySgwYKy4DQEbUaAKG28ZqQg6YIhFG3WaHkwS3FavvM23MrVyed6fvF1s//MCbK9UjBJ9NNDHNSjT4i+Uo67fw71LXacvFtRjYc2cqI2oSokzOmbER/GUUZsr//uSZOyNFFlrwAOJMvI2w0iJNCNcEA2rAi5pAsjrAuHgl6AAVXx2jGzyVFJ1KcLyk39FmuZVMFuX2dmqn/xJ8zceYk09Itz8eqRXOTkrJyXEGu60shWSCMGQAMEIVHePN2KKQTcwk69in1EogKBYWDDAMbIGC1ki8XFr+7So4tyJJiaq1+lDdzMc75vLNWGNML0LDCARmlemMA1pzQ4lSQ6IAORKlvT1a7teKlNhqLFlKsLVqmpmkKeBIcrICmzdObLMLfHtjKbZ3+8dRid619U4UzTbNbu/rJq5307+p+f2veQiM2jF/jd3HjEG+RqtxKVWqmn75+LNyfi+ye22YZjXWmo9dKsrXcx2n7NE3ELKNIcccrsAokUbkjLVdVOWRVLkMwgNnP/4/2BRq/R/a//2sWp1Y/0XcyzoZQX6P+lAGkhUFHQtEY7BCDLTqJ+oGJAYYiBsFWlSTbtfrpLr+sZZVz7UqKKLInTxmNccW+rvop5mAdXIb625g6jJTKJtPTctJB3y/h8eUng9K77b7JdsNR3YaIyLoj8YzNuOkZ625//7kmTtD4R5a8ALrDLyO0C4diQiIhAxqQIOIMvIsI/iZBCNeNpPGoO+0TYoNqX19NMA67fZ2kdiruD/Vv4KJAYhTIY76e4puiqpg1KcOUje4FIAWaioEEvm11MdXwkQJiohIoIzCFBJWaHfYk4fUVraoCJ22V2d2fWyKMGTLIVoJYubh9zDlj3bhWnQIIpIsjycpXZEPV3rMx2/SWwkT4sxvqFZduTnj2r3I+vKoFlk4zJi6OWICPDTcgysxCs2JQRQto68OIelh0zJmWxoJUMnqqKINXdUfhtHPBHSnnlrVBMOatSmCiM49p8bQk7HoYi4Skjpnsz5qm4TIZT6KeCYLQSED1AjKQCBWL5VXGG44YmCCKq9zr9siJT4eLvDK1XY1rPGex8z6e5Hf32u/tt/T/3eqi8Ah6iBDqY5y4JEwrY4oRjOSYhAIKEVvVerle++ikl+3XdOvmwjGDuKDpcQFkcFwG2ZQfCyK4xvpdOKTD6uH3x+TKdqYwASIUCw4OGshRdHwaEKDnxWbp1CoeF9Jycw74z70jmHC1FwZ5PHSGv/+5Jk8AEEb2vAC4ky8DwAyGEEqBIPjZcEziRryLcC4qRhJIiFMadJuWT8Rkcc2jPBnSWgzVw1JDCqYFCxSz/AaUP6gbdbRoC4aWI75hTSCQMKvoFTrlolzw2SAMzMmxqiNgc1GXPpXth2/Xx4s8mebNC2fdZMC6jjsIvDaXPoaa2JZWgF4vCd5YQ8UGJEwBpqSBRQCg4uQKPHZrvsexj1C0hEvtUMgtS0o7HDbCswo8OW1v3XtZfrW6f3V5kIpUfsszlyBLZsPZAruul1bGOW/M6cvB7wog32/Nol2VRxltRRrh2sjikro/XnONRQNxc0cyR+lG1RZUO+PsY+otqcYzrOzUPcrgoO+muhjhjAhONEryx5gjxr6qx1IfkrB4lJHW+xNrUJT7os921WvlO16jK5h5Q1ejAbWbV9QtRvQ5V1RJUATAQQKgs5xKwMF1gInKIPnk3DDgBnJ+2ZVDUUcmwlKVssZCk40jMMHVOV93AOzZOpBaop8mduS5wp6d/MVOk3xta8mv2io8tMGV19JsmZYWRvKdKa3I7PtSXrXmQ9//uSZPUIlDVrwTOJG/JEwLhhGYkSETWjAC4gy8jZAaHYEKQALWbLtM3Dmecr6yBFrepp8zX97aRrvP/hXS+27TLJSBP5So+2YmxmS5EIrICCaBPeowCU1z59PMzrXkmOLDtz6NQQLKTFHhiQHKGC45ruGGMCCnU9dqWf8VNqfvXZujri5O94kbiFDwjBDa98FAI/TfW+xZQ4SGdZGvvxZcPsOl5qJqbJu4QNKbSzXTuRFzfRfMrcvLaO9l8vPe2UzY0IzaCe4SfIKZTuy4TyW0ggf2+Vua9Qj3s2r8lPttSbhOmvhTZscs39z6goSn8f00Mz0zbpk5y++y10v0tpbX75UVdpLjk4IR4sRkmpCdtI/KYDHtNKfgVWVafdW4YhaSfS4mjEixC9l7yizyKnHlT7SMzGCQss6l7xiahW1K+2444QKNs3OWylpRCIEWl4JIQDMdSV0ZUt/KWzsFiwKx6UaUsW6GD0YWjV6i4VGNnUzITYSAUZKZKIFmNRdyp5qd6Ij+bOdU7Bp8WRI5ZhemxzVLTI9xyDFkaHQZ0LEFn6Gf/7kmTuCdRGa0AriTLyOwC4YQgiABBlsQAscMEJCILhQJCYiDPO6rWOPwOFd42rSlxWWp50VGJX8ECqURHSZdfKY2KDuABM7cordEcndVIRXRXZeVHH7/kLGZGu8drVpY/SyWp5lCfuVkaOgezQtjPNXIQI11LRtU/sYqlost9SUJGNLYqszFSWcKEdoCAy3D1mNDwnHZ7lGtw4DMg4rNaKm9gd2coi2T9diPT075V1/j291Vn6+J2jBKNFF9yDPGxpnUds5DloHGXVGReTlLlqZ0Jz/Gxy0C/tEpne0P9O8bGRFeD297y2w9X75Tpt1XsnV9QfTbouhCiCRtQuYOLWPQEcSxO2EkQhK6rXtY1loibHHIbnopcuuof8cd2zfixdntrUD5PpzJJWc80RZX5hk7svDcFlFQ8jCmdMu6u+w7I8UyhT/l8lme6VAmVIiPtCTc+EOAYDtWrupgWDbHd1fqevstH3wZvk7YeGkL3CWoW5BD5oOSNijT7Ps2uZ20Igi54KZkZurYwJjwwmHTGEqwIZgb5DvJ116XfboP5GhRT/+5Jk6I2DnWzBCxwYQDmjqJkgIl4QWbEADjzEiSku4QCgivmzhk8tZTlpUUMFEPzqBgo9HM4hwy+UJ08oR1FcSZFxRN0G5CUggAQSABjQDMJYp+jYRTIpLYb0DhecL4yqhwbKxL+d8EqgUIhSK60i7AixN8QjKSjxZuGiCl5HPMZrIFxvEspStazbSTr0iy12LHGUDSIEZEYAdRQDQE4MUoqas8TO8jUbFJVLa0V3iycyfGd9Mfj8YI4wP3yXBaaD94jCfFo5uIWtnBFDkoU3auxjQMOuaoiGuPGCnbHMpnKqyl0bnJB0hxPLuMpGvCLhvJXYq4UnotOEaYmvO2/FgVmcoLMis8bhZoA4US6BhligSYhp9YVStSJKtSB9cbujtbRddNKDps0dYD1DlLKQOyptampA8bud2ruZKoptptGZ82taxGGq1xVMQU1FMy4xMDABLUgjaih0JyPBs+2b731VXay7bU3t27M1Ye3779aauNP6LlngX/wG8MoFcSIdWdCNFY1FEq1ShmVfxTeZIbDas6ZzhQ75vYp0jkdri5MR//uSZOoIk9xowTNmG3JKBChWICJcDs2DBM2ga8kAgaFUJJgAlg9jit+Z+eUN3uiE7UKXBb5J0mpHxfeiqi2h9Ltw4oMD7zyDJyos0LKEz0EzcKBRbXNlI8THrDWNRUOWikacITKg0SZKOOEm1xYYiijcw6qaHGRpIahbGEwbvE4hOllnPAw09RFV5FjyXTFxJIpapwGlYugPZeHQpbSpvU5PX7Gp5HvCEhrDRMBc6gCL+/di28rNeoTaQm9Ybl/PmfZmWSU7HLYk723+F/n1oRc9700WEWYUvI7C8rSnbtlfzLbwwWH7ztzME0rf9QA3/XLNTC0ghL2piSwwyNa9McxU1Wimh1fd6tH0M1K6Pd0Yqhe9ibI9bXbVChsfqe1vWgN1IqmkZDr4oWBIek1apqYIgGy0psHa2tc5Jw3XbTjjEVFew48lmGIK0wTjsegSor1qonbOpzCy39Vj+y6uzTtbJNKZLKTeoxJL7Q9NnZkJSulzOTmP4TZiuG5NLIsCfGdpz+IlGMd9ZpM8cnjHQX28Q/iIrS1W7OjHus26qYK7cv/7kmTmiAONY8GzZhryRsBoQAUJAAwRfQ9NJGLIywEipBOIAJituueZPbQAhAYITGgYOnGEJw94M0Qi0qQn0ki/0janon0ixRCMPSNKhsNVrHxClUqRoWWnSbuleQjh7+imR9Bnki6S/r+nsac2MpcX/j02JlPGzK+5Jd4sd8+Dt4BzqhyDh3NxopFXIDNtbjcQt8zv0EP9ytlmZ/SD/I8e0ESprpNeJbZbfRi8LPBePPsdAQ2EJgYkMZnAuj1IfH6SbMfdEKRSMIV4UzvyEXsWCLvHW8zBISWuZIy6ZRJMsvP6S7QksvlgzMzkBGMrRnPl1p2JRzTUc34Q32uVaZFOHPIisJhWR+sSTU+pp22HzcGIeO60sRmdFwLto1DzLGgd5K/HzsGsJbSj/yrctqP2yiaivYNXNctG4on3Er905rN/1ebxv6M+fdUK4wKBSqdGW2zwVIVnv7a3utMvOb3l/bGfGftuF7Hq222zwJZfoVZGZzOERMabln0/WkdLUwtD00AyCExIYd3bQdGU4NUdo5brb8pnqQfqERF75qo1e8L/+5Jk/4iUP2pAs2ky8luHiDUN4wBNyYUNTRhryVYUoMAXjAkUlUEZHnj/bQ9iH9ZCpZdSXlpA8ZYF476AJkClwXDk2e6Fk6BBEEJRSkYuYNrrejldzXyzLf8Guwy0mt3YVuansZlj9SnPgcadpVq+Vbe1XIEf8dIh6nbLNf8u5BO3AefdKeZN+tLudugAIATSqJgOezmQT2NgeAjLp0qTnu01TJAZo4WIZqxB4fikqoFOk8VhFE9Bj7uRPFyrp2tunDJ6niDHjuEisFW0yXJWfU5cUGRY1UXjoo5XUY2c0bGIVUrqVRFQYOYfkTIwToCI2btNGVjCFiV/ikcKrICpgIRsicWXSFE8yXR0eUyk3FnSGHg4Hq2xS4m9lWWbkamqXF70VN2lKbDhVLnWuYZnu3qA7UcUl47bm3oAASAAhlpRqmQLAUAw9dx71VvPx6v7r9o1KavJ+6rvT195z4hXGQ8OSbaJI6ehisNSy1Gs4g4OsKKs6mHJiQLOiBplXsMupwY+jHnh1GSi2hOQqrj8Z9ToJyInqMQyMW8FCbDMjZFU//uSZOqAg3xkwTNmGvJQgzhFGCNOTfFRAq2kYsj4jKGYEIz4w5TKexEUPoiGRmLDN/QZ9IyGaoBAARQbKVomSVxqcvG8arkcianWVZYiVO7LzLBYUj+ZWSM5+VYl2XK7U3h337wmarFyRVy/oOqRc90bcmG1fnRiLdqc1f89yvfhk6XpduS/KYy0fYARUJiyNKA0y+Tv51+z1LhllHpvDWXxvbJy+a2eKxq3LxC/vy5TLgfkbpFER8Nks9eeUhkFssIZkEkaBlpnuCXHbJzMxM6QIi8E+za08/Q6SBePw/qPc6NkVUl66sTXNDPe6s45hSzMjJ8swaFxggR/yDRhu3rS31AAhGEdSj7WJcm1SPEzQIhc5m3TYGLucUZQJNWKoLB1NyQYNvYoiYe5K0uWhS8QLHQWXGngdKhpPAPdkkvHuvSFtEUtcWQjyqFVAQAFV/zgjZKKiv7zztNC7uTsR8m9aFg0TS4a4Ubf6eE34K2K3flb297uYrv8R7Vvhk33s9Pmf/vWM3m97Pjk6KaikvvJbAXlZlbqsu8TZ83xranpbv/7kmTyiBPSa0BDZhtyV2v4JQwjNA6ZlwUtGG3JJA0g1DCJmAM0woVxB1/1j7SsyuoLfkFjr6YAPkUfKEAACQWXdtnjei5tIY8kNUyYaaxz3Qam6vTw+ecXyBM8ti3paHrxk8yHSsygaWexwqCwAJB8ACUKMEL42cAApNMZIWukSilqsIcUeTm+LrJOTc3CwgAGH1XBkQAhV7IqOCrtorZ3Ykzlxp3JK/8bkcMUsN3IpNozt8whM1h4V3iudEhsjkxEZrwrOCIDr4NIRHMD84aKbTHG+G54pV+5D9LrNfai9Gsac27EttO2i17Mjswx13nL/B+NXugP2rRjakUUkEGcEg1EOCB4THydXhZ62HUCmle2bWVl5Hyqq6WyU6c3nTHxPNnanI1sUFFAllYaAqHBxxkbMaE562BQqoJerV3+lMqVpdW/7P/fX0/27F+DPV4YqrVMQU1FMy4xMDBVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVX/+5Bk6YkDZUxAq2My8lHFuCUMI1QTQZEATTBzyLCAYjABCABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVUAxzAxgWIuAaQ3UIOoZNAoYBJgEwKErIoErIlJG6RhJ0TtNtFqfK02LKKKk2EuUWYaSKsoossxJtFja17MIkst/lJN5b/dzn8xy3c52SWWa3kiqKe/3K/xL+UxzDeOUWUmSbYxxWhACTAkBRR5IKgIidHgJoSAqbR+r+vbp/9aRcBcW/9ZEJgJDBiW////SElMQU1FMy4xMDBVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVX/+5JkiI/zJha/CekxhisAB4IEIwIAAAGkAAAAIAAANIAAAARVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV"
  );
  snd.play();
};
export const isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return (
      navigator.userAgent.match(/IEMobile/i) ||
      navigator.userAgent.match(/WPDesktop/i)
    );
  },
  any: function () {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  },
};

export const isTouchDevice = () => {
  if (window.matchMedia("(pointer: coarse)").matches) {
    return true;
  }
};

export const generateDynamicLink = async (
  type,
  entityId,
  title,
  description,
  thumbnail,
  nftId
) => {
  const payload = { type, entityId };

  if (typeof window !== 'undefined') {
    payload.baseUrl = window.location.origin;
  }

  if (!!title) {
    payload.title = title;
  }
  if (!!description) {
    payload.description = description;
  }
  if (!!thumbnail) {
    payload.thumbnail = thumbnail;
  }
  if (!!nftId) {
    payload.nftId = nftId;
  }

  const resp = await ApiService.CREATE_DYNAMIC_LINK(payload);
  const shortLink = resp.result?.shortLink;
  return shortLink;
};

export const matchYoutubeUrl = (url) => {
  var p =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  if (url.match(p)) {
    return url.match(p)[1];
  }
  return false;
};
export const onShare = (platform, link, records) => {
  let url;
  let w = 500,
    h = 600;
  let left = window.screen.width / 2 - (w / 2 + 10);
  let top = window.screen.height / 2 - (h / 2 + 50);

  if (platform == "m15") {
    url = `https://www.facebook.com/sharer/sharer.php?u=${link}`;
  } else if (platform == "m16") {
    url = `https://twitter.com/intent/tweet?url=${link}`;
  } else if (platform == "Share on Instagram") {
    url = `https://www.instagram.com/?url=${link}`;
  }
  var shareWindow = window.open(
    url,
    "new window",
    "status=no,height=" +
    h +
    ",width=" +
    w +
    ",resizable=yes,left=" +
    left +
    ",top=" +
    top +
    ",screenX=" +
    left +
    ",screenY=" +
    top +
    ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no"
  );
  shareWindow.focus();
  if (records["id"]) putRecors(records);
};

export const putRecors = async (records, streamName) => {
  const {
    id,
    referralLink,
    eventType,
    eventValue,
    eventAsset,
    sharedBy,
    socialMedia,
    referralId,
  } = records;
  const ip = await getCurrentIP();
  const payload = {
    id,
    referralLink,
    eventType,
    eventValue,
    eventAsset: eventAsset,
    metaData: {
      os: platform.os.family,
      platform: platform.name,
      sharedBy,
      location: ip,
      socialMedia,
      referralId,
    },
  };
  if (kinesis) {
    kinesis.putRecords(
      {
        Records: [{ Data: JSON.stringify(payload), PartitionKey: eventType[0] }],
        StreamName: demoStreamName
      },
      (err, data) => {
        if (err) {
          console.error(err);
        }
      }
    );
  }
};

export const getCurrentIP = async () => {
  try {
    const result = await axios.get("https://api.ipify.org?format=json", {});
    return result?.data?.ip;
  } catch (error) {
    return null;
  }
};

export const putStreamRecord = async (record) => {

    

  if (
    record.eventType === "start" ||
    record.eventType === "next" ||
    record.eventType === "previous"
  ) {
    const id = uuidv4();
    association.eventType = "start";
    association.id = id;
    record.associationId = id;
  } else {
    association.eventType = record.eventType;
    record.associationId = association.id;
  }
  record.sessionId = localStorage.getItem("sessionId");

  if (kinesis) {
    kinesis.putRecords(
      {
        Records: [
          { Data: JSON.stringify(record), PartitionKey: record.eventType },
        ],
        StreamName: STREAM_NAME
      },
      async (err, data) => {
        if (err) {
        } else {
          if (record.eventType === "start") {
            const { result } = await ApiService.ATTRIBUTES();
            if (result) {
              localStorage.setItem("streamingBalance", result.streamingBalance);
              localStorage.setItem("attributes", JSON.stringify(result));
            }
          }
        }
      }
    );
  }
};
export const logger = (function () {
  var oldConsoleLog = null;
  var pub = {};

  pub.enableLogger = function enableLogger() {
    if (oldConsoleLog == null) return;

    window["console"]["log"] = oldConsoleLog;
  };

  pub.disableLogger = function disableLogger() {
    oldConsoleLog = console.log;
    window["console"]["log"] = function () { };
  };

  return pub;
})();
export const i18nHMS = (value) => {
  if (value) {
    const sec = parseInt(value, 10);
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    let seconds = sec - hours * 3600 - minutes * 60;
    if (hours) return { hr: hours, min: minutes, sec: seconds };
    if (minutes) return { min: minutes, sec: seconds };
    if (seconds) return { sec: seconds };
  } else {
    return `0 sec`;
  }
};

export const getAudienceId = async (audience) => {
  if (!Array.isArray(audience)) {
    console.warn("[getAudienceId] => audience is not an array => returning []");
    return [];
  }
  const arrayOfIds = audience.map((obj) => obj?.user?._id);
  return arrayOfIds;
};

export const putAdRecors = async (record, streamName) => {
  if (kinesis) {
    kinesis.putRecords(
      {
        Records: [
          { Data: JSON.stringify(record), PartitionKey: record["eventType"] },
        ],
        StreamName: demoStreamName,
      },
      (err, data) => {
        if (err) {
          console.error(err);
        }
      }
    );
  }
};

/**
 * Get a share URL for an asset.
 * Tries the slug API first, falls back to backend share routes (which serve OG meta tags).
 */
export const getShareUrl = async (assetType, assetId) => {
  const userId = getUserId();
  try {
    const resp = await ApiService.CREATE_SHARE_LINK({ assetType, assetId });
    const url = resp?.result?.url;
    if (url) {
      return userId ? `${url}?ref=${userId}` : url;
    }
  } catch (e) {
    console.error('getShareUrl fallback:', e);
  }
  // Fallback to backend share route (serves OG meta tags for link previews)
  const url = `${SERVER_URL}/share/${assetType}/${assetId}`;
  const sep = url.includes('?') ? '&' : '?';
  return userId ? `${url}${sep}ref=${userId}` : url;
};

/**
 * Copy a share URL to clipboard. Works in Safari (which loses user gesture after await).
 * Must be called synchronously from the click handler — pass the promise, don't await first.
 */
export const copyShareUrl = async (assetType, assetId) => {
  const urlPromise = getShareUrl(assetType, assetId);

  // Safari: clipboard.write() called synchronously preserves user gesture,
  // while the blob data resolves async via the promise
  if (typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
    try {
      const item = new ClipboardItem({
        'text/plain': urlPromise.then(text => new Blob([text], { type: 'text/plain' })),
      });
      await navigator.clipboard.write([item]);
      return await urlPromise;
    } catch (e) {
      // fall through for browsers that don't support promise-based ClipboardItem
    }
  }

  // Chrome/Firefox: await is fine, user gesture persists
  const url = await urlPromise;
  await navigator.clipboard.writeText(url);
  return url;
};
